import { useState } from "react";

interface IDashboard {
  tab: string;
  open: boolean;
}
const useDashboard = () => {
  const [state, setState] = useState<IDashboard>({
    tab: "Video",
    open: true,
  });

  const setTab = (tabName: string) => {
    setState((currentState) => ({
      ...currentState,
      tab: tabName,
    }));
  };

  const setOpen = () => {
    setState((currentState) => ({
      ...currentState,
      open: !state.open,
    }));
  };

  return {
    ...state,
    setTab,
    setOpen,
  };
};
export default useDashboard;
